import { useContext } from "react";
import { PROFILE_END_POINT } from "../../../../constants/ApiConstant";
import Breadcrumb from "../../../../reuseable/Breadcrumb/Breadcrumb";
import {
  PROFILE_LABLE,
  SLACE,
} from "../../../../reuseable/Breadcrumb/BreadcrumbConstant";
import UserContext from "../../../../context/UserContext/UserContext";
import sweetConfirmationDeleteAccount from "../../../../reuseable/sweetConfirmationDeleteAccount";
import { Button } from "primereact/button";
import { useMutation, useQuery } from "react-query";
import { User_Account_delete } from "../../../../Apis/userApi/UserApi";
import { getDetailsQrOrganization } from "../../../../Apis/orgApi/OrgApi";
import { IsLoadingResponse } from "../../../../utils/Helper";
import { useNavigate } from "react-router-dom";

const Profile = () => {
  const { userProfile } = useContext(UserContext);
  const history = useNavigate();

  const { mutate: statusChangeMutate } = useMutation((formData) =>
    User_Account_delete(formData, history),
  );

  const { data, isLoading, error } = useQuery(
    ["getDetailsQROrganization", userProfile?.hwId],
    () => getDetailsQrOrganization(userProfile.hwId),
    {
      enabled: !!userProfile?.hwId, // 👈 API will run only if hwId exists
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      keepPreviousData: true,
      refetchOnReconnect: false,
      retry: 3,
    },
  );

  const handleDeleteProfile = async () => {
    let { isConfirmed } = await sweetConfirmationDeleteAccount();
    if (isConfirmed) {
      let formDate = {
        pageUuid: data?.orgPageDetail?.pageUuid,
        isActive: false,
      };

      statusChangeMutate(formDate);
    }
  };

  return (
    <>
      <Breadcrumb
        name={PROFILE_END_POINT}
        slace={SLACE}
        name1={PROFILE_LABLE}
      />
      <IsLoadingResponse isLoading={isLoading || !userProfile?.hwId} />
      <div className="card p-5">
        <p>Org Name : {userProfile.orgName}</p>
        <p>hwId : {userProfile.hwId}</p>
        <Button
          label="Delete Account"
          className="p-button p-component flex-auto "
          style={{ height: "44px", width: "300px" }}
          type="button"
          onClick={handleDeleteProfile}
        />
      </div>
    </>
  );
};

export default Profile;
